import { trim } from '../../libs/utils/paramTrim'

export default {
  data() {
    return {
      dialogTitle: '', // 主弹窗标题
      type: '', // 弹窗类型
      dialogId: '', // 弹窗打开时传递的数据 id
      handleBtnTip: '', // 提示弹窗的提示语
      handleDialogVisible: false, // 提示弹窗的显示与否
      mainDialogVisible: false, // 指定类型弹窗（主弹窗）显示与否
      dicType: { // 设置对应按钮格式化字典
        add: '新增',
        edit: '修改',
        del: '删除',
        forbbiden: '禁用',
        unforbbiden: '反禁用',
        reload: '重启',
        unpackLog: '设备管理',
        doorManage: '设备管理',
        updateUser: '变更领取人',
        updateDeliveryManTel: '变更配送员',
        getClientLog: '获取客户端日志',
        up: '上架',
        down: '下架',
        reSend: '重发短信'
      },
      FORBIDDEN: '1', // 禁用
      UNFORBBIDEN: '0', // 未禁用
      msg: '', // 弹窗类型信息
    }
  },
  methods: {
    handleBtn(type, param) {
      this.type = type // 设置点击按钮类型
      this.dialogId = this.selection[0] ? this.selection[0].id : '' // 设置选中数据的id
      this.dialogTitle = `${this.dicType[type]}` // 设置主弹窗标题

      const selectionLen = this.selection.length // 选中的数据条数
      const onlySelectOne = ['edit', 'reload', 'del', 'forbbiden', 'unforbbiden', 'up', 'down'] // 只能选一条数据
      const selectMore = ['updateDeliveryManTel', 'updateUser'] // 至少选择一条数据
      if (type === 'add') {
        this.mainDialogVisible = true // 不需要进行一下判断，直接打开弹窗
        return false
      }
      if (selectMore.includes(type)) { // 变更领取人， 变更配送员
        if (selectionLen === 0) {
          this.handleNotify('error', '错误', `请至少选择一条 ${this.dicType[type]} 数据`)
          return ''
        }
        this.handleChangeReciveUser()
      }
      if (onlySelectOne.includes(type)) { // 符合 onlySelectOne 的操作类型
        const isSelectOne = this.handleSelectOne(selectionLen, type) // 只能选一条数据
        if (!isSelectOne) { // 不符合 只选了一条数据
          return false
        }
        switch (type) {
        case 'reload':
          this.handleRestartDevice(param.data)
          return false
        case 'del':
          this.delCheck()
          return false
        case 'forbbiden':
        case 'unforbbiden':
          this.handleForbbiden(type)
          return false
        case 'edit':
          this.handleEditBefore(type)
          return false
        case 'up':
        case 'down':
          this.handlePackageStatus(type)
          return false
        default:
          this.mainDialogVisible = true // 不需要进行一下判断，直接打开弹窗
          return false
        }
      }
      return ''
    },
    // 只能选择一条数据
    handleSelectOne(selectionLen, type) {
      // 限定选且仅选一条数据
      if (selectionLen > 1) {
        this.handleNotify('error', '错误', `每次只能选择一条 ${this.dicType[type]} 数据`)
        return false
      }
      if (selectionLen === 0) {
        this.handleNotify('error', '错误', `请选择一条 ${this.dicType[type]} 数据`)
        return false
      }
      return true
    },
    // 提示弹窗 点击确定后调用函数
    handleDialogComfirm(message) {
      this.msg = message
      switch (this.type) {
      case 'del':
        this.delList()
        break
      default: break
      }
    },
    handleDialogClose() {
      this.handleDialogVisible = false
    },
    handleConfirm(message) { // 主弹窗的确定按钮调用该函数
      // 获取子组件（弹窗）中的表单数据
      this.msg = message
      const { dialogFormData } = this.$refs.dialogForm
      // 根据请求类型，确认是 新增 还是 修改
      const URL = this.type === 'add' ? this.addUrl : this.editUrl
      this.handleAddEdit(URL, dialogFormData)
    },
    ifForbidden() {
      const { forbbiden, disabledStatus } = this.selection[0]
      if (forbbiden === this.FORBIDDEN || disabledStatus === this.FORBIDDEN) {
        return {
          code: 0,
          msg: '该数据已经禁用，不能删除'
        }
      }
      return {
        code: 1,
        msg: ''
      }
    },
    delCheck() { // 删除校验
      // 对于已经禁用的数据不能删除
      const canDel = this.ifForbidden()
      if (canDel.code === 0) {
        this.handleNotify('error', '错误', canDel.msg)
        return
      }
      if (this.handleDelBefore) {
        const reqRes = this.handleDelBefore()
        reqRes.then(res => {
          this.handleBtnTip = res.msg || '确定要删除该数据吗？'
          if (res.canDelete === '0') { // canDelete 确定是否可以删除
            this.handleDialogVisible = true
          } else {
            this.handleDialogVisible = false
            this.handleNotify('error', '错误', res.msg)
          }
        })
      } else {
        this.handleBtnTip = '确定要删除该数据吗？'
        this.handleDialogVisible = true
      }
    },
    delList() { // 删除table数据
      let delIds = this.selection.map(item => item.id)
      if (this.handleDeldata) { // 对删除的数据进行处理
        delIds = this.handleDeldata()
      }
      // 删除其他用户前检查“投递列表”是否已经存在该该账号的配送记录。如果有，提示：该用户已有历史配送记录，不能进行删除，请使用禁用用户。
      this.$http.post(this.delUrl, delIds)
        .then(res => {
          // 这里判断 返回的code 成功与否， 如果失败弹出一个提示
          this.handleDialogVisible = false // 关闭弹窗
          if (this.handleDelTip) {
            const tips = this.handleDelTip(res)
            if (tips.code === 0) {
              this.handleNotify('error', '错误', tips.msg)
              return false
            }
          }
          if (res.data.code !== 1) {
            this.handleNotify('error', '错误', res.data.msg || `删除${this.msg?this.msg:'用户'}数据错误`)
            return false
          }
          this.handleNotify('success', '提示', `删除${this.msg?this.msg:'用户'}数据成功`)
          this.searchTableData() // 刷新表格数据
          this.tableRadio = -1 // 重置单选按钮选中位置
          return ''
        }).catch(() => {
          this.handleDialogVisible = false // 关闭弹窗
        })
      return ''
    },
    handleForbbiden(type) {
      let forbbidenId = 1 // 禁用
      if (type === 'unforbbiden') {
        forbbidenId = 0 // 未禁用
      }
      if (this.repeatForbbiden) { // 禁止重复禁用、反禁用
        const res = this.repeatForbbiden(type)
        if (res) {
          return
        }
      }

      let param = this.selection.map(item => ({ roleId: item.id, forbidden: forbbidenId }))
      if (this.formatForbbidenData) {
        param = this.formatForbbidenData(type)
      }
      this.$http.post(this.forbbidenUrl, param)
        .then(res => {
          if (this.forbbidenTip) { // 处理禁用、未禁用 请求后提示
            const tips = this.forbbidenTip(res)
            if (!tips) { // 判断禁用的是admin
              this.handleNotify('error', '错误', `该用户是 admin 不能被 ${this.dicType[this.type]} `)
              return
            }
          }
          if (!res.data) {
            this.handleNotify('error', '错误', '响应超时，请重新登录')
          }
          if (res.data.code !== 1) {
            this.handleNotify('error', '错误', `${this.dicType[this.type]}用户数据错误`)
          } else {
            this.handleNotify('success', '提示', `${this.dicType[this.type]}用户数据成功`)
            this.searchTableData() // 刷新表格数据
            this.tableRadio = -1 // 重置单选按钮选中位置
          }
        })
    },
    repeatForbbiden(type) { // 禁用的不能再禁用，未禁用的不能再反禁用
      const { disabledStatus, forbbiden } = this.selection[0]
      // 禁用的不能再禁用，未禁用的不能反禁用
      const forbiddens = disabledStatus === this.FORBIDDEN || forbbiden === this.FORBIDDEN
      const unforbiddens = disabledStatus === this.UNFORBBIDEN || forbbiden === this.UNFORBBIDEN
      if (forbiddens && type === 'forbbiden') { // 该条数据已经禁用，不能再禁用
        this.handleNotify('error', '错误', '该条数据已经禁用，不能再禁用,请选择未禁用数据')
        return true
      }
      if (unforbiddens && type === 'unforbbiden') { // 该条数据已经f反禁用，不能再反禁用
        this.handleNotify('error', '错误', '该条数据未禁用，不能反禁用，请选择已禁用数据')
        return true
      }
      return false
    },
    handleNotify(type, title, message) { // 处理侧边提示信息框
      this.$notify({
        type,
        title,
        message
      })
    },
    handleEditBefore(type) { // 处理 修改 初始化传参
      if (this.initEditFormData) {
        this.initEditFormData(type)
      }
      this.mainDialogVisible = true // 打开修改弹窗
    },
    handleAddEdit(url, dialogFormData) { // 新增 或 修改
      // 新增或修改前的校验
      if (this.handleAddEditBefore) { // handleAddEditBefore 这是一个 async await 函数
        const requstRes = this.handleAddEditBefore(this.type) // 新增修改，对输入字段校验
        requstRes.then(res => {
          if (res.code) { // 符合校验
            this.handleAddEditAfterCheck(url, dialogFormData)
          } else {
            this.handleNotify('error', '错误', res.msg || `${this.dicType[this.type]}${this.msg?this.msg:'用户'}数据错误`)
          }
        })
      } else {
        this.handleAddEditAfterCheck(url, dialogFormData)
      }
    },
    // 当增加、修改前添加的校验通过时候调用
    handleAddEditAfterCheck(url, dialogFormData) {
      this.$refs.dialogForm.$children[0].validate(valid => {
        if (valid) { // 校验表单是否验证通过
          // 对表单数据进一步处理
          let formdata = { ...dialogFormData }
          if (this.handleFormatFormdata) {
            const result = this.handleFormatFormdata(this.type, dialogFormData)
            if (result.code === 0) { // 校验不通过
              return // 中断下面请求操作
            }
            formdata = result.data
          }
          // 对 formdata 进行去除空格处理
          trim(formdata, formdata)
          // 进行接口请求，当请求成功时候，重新刷新table
          this.$http.post(url, formdata) // 新增 修改
            .then(res => {
              // 这里判断 返回的code 成功与否， 如果失败弹出一个提示
              if (res.data.code !== 1) {
                this.handleNotify('error', '错误', res.data.msg || `${this.dicType[this.type]}${this.msg?this.msg:'用户'}数据错误`)
                return
              }
              if (this.handleAddEditTip) { // 处理新增、修改的返回额外提示
                const tipBoolean = this.handleAddEditTip(this.type, res)
                if (!tipBoolean) {
                  return
                }
              }
              this.handleNotify('success', '提示', `${this.dicType[this.type]}${this.msg?this.msg:'用户'}数据成功`)
              this.mainDialogVisible = false // 关闭弹窗
              // 重新请求table数据
              this.searchTableData()
              this.tableRadio = -1 // 重置单选按钮选中位置
            }).catch(() => {
              this.mainDialogVisible = false // 关闭弹窗
            })
        }
      })
    },
    // 重启设备
    handleRestartDevice(param) {
      const restartType = param === 'software' ? 2 : 1
      const tips = param === 'software' ? '重启软件设备成功' : ' 重启硬件设备成功'
      const { id, deviceNumber } = this.selection[0]
      this.$http.post(this.restartUrl,
        { deviceNumber, restartType, id })
        .then(res => {
          if (res.data.code === 1) {
            this.handleMessage('success', tips)
          } else {
            this.handleMessage('error', res.data.msg || '重启设备失败')
          }
        })
      this.tableRadio = -1 // 重置单选按钮选中位置
      this.selection.length = 0 // 清空selection中的数据
    },
    handleMessage(type, message) {
      this.$message({
        showClose: true,
        message,
        type
      })
    }
  }
}
